import React, { Component } from "react";

const DairyIcon = ({ width, height, fill, ...rest }) => {
  return (
    // <svg
    //   width={width}
    //   height={height}
    //   viewBox="0 0 16 20"
    //   fill="none"
    //   {...rest}
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M14.09 9.76066V7.73301H12.3495V5.22449L10.5486 2.33676V0H1.80094V2.33676L0 5.22449V20H15.6008V12.1831L14.09 9.76066ZM12.9181 9.76066L11.6682 11.7649H7.70687L8.74762 10.0961V8.90484H12.9181V9.76066ZM11.1777 5.55996V7.73301H8.74762V5.55996L9.96262 3.61176L11.1777 5.55996ZM2.97281 2.67223V1.17188H9.37668V2.33676L7.83656 4.80629H1.64187L2.97281 2.67223ZM1.17187 18.8281V5.97816H7.57574V9.76066L6.06496 12.1831V18.8281H1.17187ZM7.23684 12.9368H11.4073V18.8281H7.23684V12.9368ZM14.4289 18.8281H12.5792V12.5186L13.504 11.0356L14.4289 12.5186V18.8281Z"
    //     fill={fill}
    //   />
    // </svg>
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.09 9.76066V7.73301H14.3495V5.22449L12.5486 2.33676V0H3.80094V2.33676L2 5.22449V20H17.6008V12.1831L16.09 9.76066ZM14.9181 9.76066L13.6682 11.7649H9.70687L10.7476 10.0961V8.90484H14.9181V9.76066ZM13.1777 5.55996V7.73301H10.7476V5.55996L11.9626 3.61176L13.1777 5.55996ZM4.97281 2.67223V1.17188H11.3767V2.33676L9.83656 4.80629H3.64187L4.97281 2.67223ZM3.17187 18.8281V5.97816H9.57574V9.76066L8.06496 12.1831V18.8281H3.17187ZM9.23684 12.9368H13.4073V18.8281H9.23684V12.9368ZM16.4289 18.8281H14.5792V12.5186L15.504 11.0356L16.4289 12.5186V18.8281Z"
        fill={fill}
      />
    </svg>
  );
};

DairyIcon.default = {
  width: 16,
  height: 20,
  fill: "black",
};

export default DairyIcon;
